import React, { Component } from "react";
import PageSubmitButton from './PageSubmitButton';
import GravityForm from "react-gravity-form";

export default class PageContact extends Component {
  	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id}>
			    			    		
		    		<div className="l-grid l-grid--m-reverse">
		    		
		    			<div className="l-grid__col l-grid__col--m-6-12">
		    					    			
			    			<div className="c-page__block c-page__block--load-effect">
			    						    						    			
								<div className="scope-text scope-text--contact" dangerouslySetInnerHTML={{__html:block.information}}></div>
									
							</div>
						
						</div>
						
						<div className="l-grid__col l-grid__col--m-2-12"></div>
						
						<div className="l-grid__col l-grid__col--m-4-12 c-contact__form">
						
							<div className="c-page__block c-page__block--load-effect">
								
								<div className="scope-form">
									<GravityForm
										backendUrl={document.location.origin + '/wp-json/bastings/v1/form'}
										formID={block.form_id}
									/>
								</div>
							
							</div>
							
						</div>
		    			
		    		</div>
			    					    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
